import React from 'react'
import { TabUnstyled, TabsListUnstyled } from '@mui/base'
import { styled } from '@mui/material/styles'


const Tab = styled(TabUnstyled)(({ theme }) => ({
    position: 'relative',
    padding: '10px 30px',
    transition: '0.3s',
    cursor: 'pointer',
    border: 'none',
    background: '#a19fa0',
    color: '#fff',
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
        padding: '10px 20px',
    },
    '&:hover': {
        opacity: 0.7,
    },
    '&.Mui-selected::before': {
        content: '""',
        position: 'absolute',
        bottom: '-9px',
        left: '50%',
        transform: 'translateX(-50%)',
        borderTop: '10px solid #ffa500',
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
    },
    '&.Mui-selected': {
        background: '#ffa500',
    },
}))

const TabList = styled(TabsListUnstyled)({
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: 4,
    rowGap: 12,
})

const VideoTab = ({ data }) => {

    return (
        <TabList>
            {data.map((d, i) => (
            <Tab
                key={d.タブ}
                value={i}
                className={d.タブ}>
                {d.タブ}
            </Tab>
            ))}
        </TabList>)
}

export default VideoTab
